export default __webpack_public_path__ + "static/media/Earth.220719bf.png";